import React, { useEffect, useState } from "react";
import { optionData } from "./formConfig";
import { CSSTransition } from "react-transition-group";
import VendorHeaderHoc from "./VendorHeaderHoc";
import LayoutHOC from "../LayoutHOC";
import SelectComponent from "../UniversalComponents/SelectComponent";
import DatePicker from "react-datepicker";
import Input from "../UniversalComponents/InputComponent";
import "react-datepicker/dist/react-datepicker.css";
import MemoArea from "../UniversalComponents/MemoArea";
import FileAttachment from "../UniversalComponents/FileAttachment";
import TableComponent from "../UniversalComponents/TableComponent";
import Button from "../UniversalComponents/DefaultButton";
import InputComponent from "../UniversalComponents/InputComponent";
import DatePickerComponent from "../UniversalComponents/DatePickerComponent";
import TimePickerComponent from "../UniversalComponents/TimePickerComponent";
import SearchBar from "../UniversalComponents/SearchBar";
import ButtonGroup from "../UniversalComponents/ButtonGroup";
import ManageTagsDrawer from "../UniversalComponents/ManageTagsDrawer";
import { NODE_URL } from "../../utils/constants";
import { useDispatch, useSelector } from "react-redux";
import { FieldValue } from "@firebase/firestore";
import CustomFields from "../UniversalComponents/CustomFields";
import { useCreateVoucherMutation } from "../../utils/customer/customerSelect";
import useRequireAuth from "../../utils/useRequireAuth";
import { pushAlert } from "../../utils/alertSlice";
import Loader from "../UniversalComponents/Loader";
import AutofillBill from "./AutofillBill";
import AiExtractorIcon from "../../assets/images/AiExtractorImage.svg";
import { AnimatePresence, motion } from "framer-motion";
const flattenValues = (obj) => {
  let result = [];
  for (let key in obj) {
    if (typeof obj[key] === "object" && !Array.isArray(obj[key])) {
      result = result.concat(obj[key]?.fields);
    } else {
      result.push(obj[key]);
    }
  }
  return result;
};

const calculateTotalAmount = (listOfObjects) => {
  const totalAmount = listOfObjects?.reduce((acc, item) => {
    if (item?.amount) return acc + parseInt(item?.amount);
    return acc;
  }, 0);
  return totalAmount || 0;
};

const iterateCalculate = (listOfObjects, formData) => {
  const filteredData = listOfObjects?.map((EachTable) => formData[EachTable.id]);
  let totalAmountList = filteredData?.map((item) => calculateTotalAmount(item));
  return totalAmountList?.reduce((acc, item) => acc + parseInt(item), 0) || 0;
};

// const formConfig = fieldValues;
const DynamicVoucherForm = ({ formConfig, voucher }) => {
  const [formData, setFormData] = useState({});
  const [linkAction, setLinkAction] = useState("");
  const [formError, setFormError] = useState({});
  const [tagList, setTagList] = useState([
    { tagName: "sparx", groupLabel: "Group 1", groupId: 1 },
    { tagName: "kazo", groupLabel: "Group 2", groupId: 2 },
    { tagName: "puma", groupLabel: "Group 3", groupId: 3 },
    { tagName: "Hero", groupLabel: "Group 4", groupId: 4 },
    { tagName: "ferrari", groupLabel: "Group 2", groupId: 2 },
    { tagName: "Honda1", groupLabel: "Group 3", groupId: 3 },
    { tagName: "Thar", groupLabel: "Group 4", groupId: 4 },
    { tagName: "Hyundai", groupLabel: "Group 1", groupId: 8 },
    { tagName: "Xuv", groupLabel: "Group 2", groupId: 2 },
    { tagName: "Lakme", groupLabel: "Group 1", groupId: 1 },
    { tagName: "lifestyle", groupLabel: "Group 5", groupId: 5 },
    { tagName: "westside", groupLabel: "Group 2", groupId: 2 },
    { tagName: "sketchers", groupLabel: "Group 1", groupId: 1 },
    { tagName: "Volvo", groupLabel: "Group 3", groupId: 3 },
    { tagName: "Hitachi", groupLabel: "Group 2", groupId: 2 },
    { tagName: "MG", groupLabel: "Group 5", groupId: 5 },
    { tagName: "Sony", groupLabel: "Group 4", groupId: 4 },
    { tagName: "Tata", groupLabel: "Group 2", groupId: 2 },
    { tagName: "kia", groupLabel: "Group 2", groupId: 2 },
    { tagName: "Mahindra", groupLabel: "Group 2", groupId: 2 },
    { tagName: "starbucks", groupLabel: "Group 1", groupId: 1 },
    { tagName: "Zudio", groupLabel: "Group 3", groupId: 3 },
    { tagName: "Barista", groupLabel: "Group 2", groupId: 2 },
    { tagName: "adidas", groupLabel: "Group 4", groupId: 4 },
  ]);

  const [groupList, setGroupList] = useState([
    { groupId: 1, value: "Group 1", label: "Group 1", color: "red", showTag: false },
    { groupId: 2, value: "Group 2", label: "Group 2", color: "green", showTag: false },
    { groupId: 3, value: "Group 3", label: "Group 3", color: "blue", showTag: false },
    { groupId: 4, value: "Group 4", label: "Group 4", color: "yellow", showTag: false },
    { groupId: 5, value: "Group 5", label: "Group 5", color: "orange", showTag: false },
  ]);

  const [openAiExtractor, setAiExtractor] = useState(false);
  useEffect(() => {
    setFormData({});
    setFormError({});
    setLinkAction("");
  }, [voucher?.id]);
  // useEffect(()=>{
  //   setFormData({})
  //   setLinkAction("")
  // },[formConfig?.section2?.fields])

  const user = useRequireAuth();
  const dispatch = useDispatch();
  const token = user?.token;
  const orgId = user?.org_id;
  const userId = user?.user_id;
  const storedData = localStorage.getItem("company_data");
  const myUserData = localStorage.getItem("myUserData");

  const usetoken = myUserData ? JSON.parse(myUserData) : null;
  const tokens = token ? token : usetoken.token;
  const companyId = storedData ? JSON.parse(storedData).company_id : null;

  // const user=useSelector(state=>state.user)
  // const Authtoken = user.token;
  // useEffect(async () => {
  //   const url="accounts/vendors/all"
  //   const SAVE_CONTACT = `${NODE_URL}${url}`
  //   const response = await fetch(SAVE_CONTACT, {
  //     method: "GET",
  //     headers: {
  //       Authorization: `Bearer ${Authtoken}`,
  //       "Content-Type": "application/json",
  //     },

  //   });

  //   const data = await response.json();
  //   console.log(data,"data aakash")
  // })

  // if(true){
  //   const [selectedOne, setSelectedOne] = useState([]);
  // }

  const [
    triggerCreateVoucherQuery,
    { data: createVoucherData, error: createVoucherError, isLoading: createVoucherLoading },
  ] = useCreateVoucherMutation();

  const handleCreateVoucher = async () => {
    const newError = {};
    Object.keys(formConfig).forEach((eachSection) => {
      formConfig[eachSection].fields.forEach((eachField) => {
        console.log(eachField, "formData[eachField?.id]");
        if (eachField?.isCompulsory) {
          if (!Boolean(formData[eachField?.id])) {
            newError[eachField?.id] = `Please fill ${eachField?.label} field`;
          }
          if (Array.isArray(formData[eachField?.id]) && formData[eachField?.id]?.length == 0) {
            newError[eachField?.id] = `Please fill ${eachField?.label} field`;
          }
        }
      });
    });
    setFormError(newError);
    if (Object.keys(newError).length > 0) {
      // console.log(newError, "newError aakash");
      dispatch(pushAlert({ type: "danger", message: "Please Check Form Errors", visible: true }));
      return;
    } else {
      const listFormData = flattenValues(formConfig);
      console.log(listFormData, "listFormData");
      const FormPayload = listFormData
        .filter((item) => formData[item?.id])
        .map((item) => {
          return {
            id: item.id,
            transaction_mode: item.transaction_mode,
            value: formData[item.id],
            label: item.label,
          };
        });
      const payload = {
        voucher_type_id: voucher.id,
        user_id: userId,
        company_id: companyId,
        org_id: orgId,
        date: new Date().toISOString().slice(0, 10),
        fields: FormPayload || [],
      };

      // ******* sample payload ****** //
      /**
   const payloadExample = {    
      voucher_type_id: "dec67ee0-ab28-11ef-b856-bc241138112c", 
      date: "2024-11-18",    
      user_id: 6,    
      company_id: 5,    
      org_id: 6,   
      fields: [
        {
          id: "747d7709-ab29-11ef-b856-bc241138112c",    				  
          transaction_mode: "credit",            
          value: "55894018-a193-11ef-a579-bc241138112c"        
        },        
        {           
          id: "747d7cb6-ab29-11ef-b856-bc241138112c",     				 
          transaction_mode: null,             
          value: ["747d7cb6-ab29-11ef-b856-bc241138112c",
                  "747d7cb6-ab29-11ef-b856-bc241138112c"
                  ]        
        },        
         ]
    }
  **/
      const response = await triggerCreateVoucherQuery({ payload, tokens }).unwrap();
      if (response) {
        dispatch(pushAlert({ type: "success", message: response?.message, visible: true }));
      } else {
        dispatch(pushAlert({ type: "danger", message: response?.message || "Voucher not created", visible: true }));
      }
      // console.log(data,"data formError aakash")
      // console.log(payload,"form created Successfully formError aakash")
    }
  };

  const handleLinkClick = (key) => {
    console.log(key, "add Nutton");
    setLinkAction(key);
  };

  const handleInputChange = (e) => {
    const { name, value, ...rest } = e.target;

    console.log(rest, "vaibhav jain");
    setFormData((prev) => ({
      ...prev,
      [name]: value, // Dynamically update the value for the field
      ...rest,
    }));
  };
  console.log(formData, "formData vaibhav jain today");

  const renderTable = ({ tableData, onChange, value }) => (
    <div>
      <TableComponent tableData={tableData} onChange={onChange} value={value} />
    </div>
  );

  // const data = useSelector((state) => state);

  // console.log(data, "state Aakash");

  const handleAiExtractor = () => {
    setAiExtractor((prevState) => !prevState);
  };

  return (
    <>
      {createVoucherLoading && <Loader isOpen={createVoucherLoading} />}
      <div className="flex p-10 pt-0 space-x-2">
        <AnimatePresence>
          {openAiExtractor && (
            <motion.div
              initial={{ x: "-100%" }}
              animate={{ x: 0 }}
              exit={{ x: "-100%" }}
              transition={{ duration: 0.5 }}
              className="left-menu"
            >
              <AutofillBill handleAiExtractor={handleAiExtractor} />
            </motion.div>
          )}
        </AnimatePresence>
        <div className="w-full mx-auto  space-y-8 text-md">
          {/* Section 1 */}
          <div className="flex items-start space-x-4 ">
            <AnimatePresence>
              {!openAiExtractor && (
                <motion.button
                  onClick={() => setAiExtractor((prev) => !prev)}
                  initial={{ opacity: 0, scale: 0.5 }}
                  animate={{ opacity: 1, scale: 1, rotate: 0 }}
                  exit={{ opacity: 0, rotate: 90, scale: 0 }}
                  // animate={{ rotate: openAiExtractor ? 90 : 0 }}
                  transition={{ duration: 0.5 }}
                >
                  <img src={AiExtractorIcon} className="w-32" alt="AI Extractor Icon" />
                </motion.button>
              )}
            </AnimatePresence>
            <div className="flex-grow space-y-4 bg-white p-4 pb-6 rounded-[5px] border border-[#1d4469]/20">
              {/* <h2 className="text-lg font-semibold">Section 1</h2> */}
              <div className=" grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 !mt-0">
                {formConfig?.section1?.fields.map((field, idx) => (
                  <div key={idx}>
                    <CustomFields
                      field={field}
                      onChange={handleInputChange}
                      value={formData[field.id]}
                      handleLinkClick={handleLinkClick}
                      voucher={voucher}
                      fieldError={formError[field?.id]}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Section 2 */}
          <div className="space-y-4">
            {/* <h2 className="text-lg font-semibold">Section 2</h2> */}
            {console.log(formConfig?.section2?.fields, "formConfig?.section2?.fields")}
            {formConfig?.section2?.fields.map((EachTable, idx) => (
              <div key={idx} className="mb-4">
                <TableComponent
                  tableData={EachTable}
                  onChange={handleInputChange}
                  value={formData[EachTable?.id]}
                  voucher={voucher}
                  totalVoucherAmount={iterateCalculate(formConfig?.section2?.fields, formData)}
                  tableError={formError[EachTable?.id]}
                />
                {/* {renderTable({ tableData: EachTable, onChange: handleInputChange, value: formData[EachTable.id] })} */}
              </div>
            ))}
          </div>

          {/* Section 3 */}
          <div className="space-y-4 bg-white p-4 rounded-[5px] border border-[#1d4469]/20">
            {/* <h2 className="text-lg font-semibold">Section 3</h2> */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {console.log(formConfig?.section3?.fields, "formConfig?.section3?.fields")}
              {formConfig?.section3?.fields.map((field, idx) => (
                <div key={idx}>
                  <CustomFields
                    field={field}
                    onChange={handleInputChange}
                    value={formData[field.id]}
                    handleLinkClick={handleLinkClick}
                    voucher={voucher}
                    fieldError={formError[field?.id]}
                  />
                </div>
              ))}
            </div>
          </div>

          {/* section 4 */}

          <div className="flex justify-between py-3 items-center ">
            <div className="">
              <ul className="flex space-x-3  text-[#009CBF] text-12 font-400">
                {optionData.map((option) => (
                  <li key={option}>{option}</li>
                ))}
              </ul>
            </div>

            <div className="flex  space-x-2  ">
              <div className="w-[284px] bg-[#D4EAEE] border-[#BEDADF] flex justify-between text-16 text-[#535252] items-center rounded-5px px-2">
                <span className="font-400">Total</span>
                <span className="font-600 ">$ {iterateCalculate(formConfig?.section2?.fields, formData)}</span>
              </div>

              <ButtonGroup
                primaryText="Save"
                primaryClick={() => handleCreateVoucher()}
                primaryType="submit"
                secondaryText="Cancel"
                secondaryClick={() => console.log("cancel", formData)}
              />

              {/* <Button variant="secondary">
            CANCEL
          </Button>
          {/* <Button type="primary" style={{ color: "#535252" }}>
            SAVE
          </Button> */}
              {/* <Button variant="primary" onSubmit> 
            SAVE
          </Button> */}
            </div>
          </div>
        </div>
      </div>

      {linkAction === "manageTags" && (
        <ManageTagsDrawer
          open={linkAction === "manageTags"}
          close={() => setLinkAction("")}
          tagList={tagList}
          setTagList={setTagList}
          groupList={groupList}
          setGroupList={setGroupList}
        />
      )}
    </>
  );
};

export default DynamicVoucherForm;
